// extracted by mini-css-extract-plugin
export default {"flex-row":"styles_flex-row__DoJsD","common-name":"styles_common-name__3I2Y0","inn":"styles_inn__tzr-N","role":"styles_role__MvRNW"};